import { Mail } from "lucide-react";
import Reveal from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function Faq() {
  return (
    <section id="faq" className="bg-[#F3EDE2] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#C86D51] mb-4">Questions</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2C221E]">
              Before you<br />preheat the <em className="italic text-[#2A524A]">oven</em>
            </h2>
            <p className="mt-5 text-[#6E5E57] leading-relaxed max-w-sm">
              Everything bakers usually ask us. Something else on your mind? We answer every
              note personally.
            </p>
            <a
              href="mailto:info@almobakes.com"
              data-testid="faq-contact-link"
              className="mt-7 inline-flex items-center gap-2.5 rounded-full border border-[#2C221E]/25 px-6 py-3 text-sm font-medium text-[#2C221E] hover:bg-[#2C221E] hover:text-[#FAF7F2] transition-all duration-300"
            >
              <Mail className="w-4 h-4" /> info@almobakes.com
            </a>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-[#2C221E]/12">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-lg sm:text-xl font-medium text-[#2C221E] hover:no-underline hover:text-[#6A2C3E] transition-colors py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-[#6E5E57] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
